<!--
 * @Description: 综合素质评价 列表
 * @Author: PF
 * @Date: 2022-09-23 11:53:25
 * @LastEditors: PF
 * @LastEditTime: 2024-09-10 16:24:54
-->
<template>
  <div>
    <el-dialog class="wp90 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close style="min-width: 1030;">
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">综合素质评价</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
    <el-container>
      <el-header class="pl0 pr0">
        <!-- 搜索区域 BEGIN -->
        <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
          <el-form-item>
            <el-select placeholder="学期" v-model="dataGrid.parms.pjxqid" clearable @change="bindTable()">
              <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="标题" v-model="dataGrid.parms.kcmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
              <template #suffix>
                <el-icon class="el-input__icon pointer" @click="bindTable()">
                  <search />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <!-- 搜索区域 END -->
      </el-header>
      <el-main class="pl0 pr0">
        <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
          <!-- 冻结列-Left BEGIN -->
          <el-table-column label="序号" type="index" width="80" fixed align="center" />
          <el-table-column label="标题" prop="bt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="评价学期" prop="pjxqmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="参评人" prop="cprlx" align="center" show-overflow-tooltip>
            <template #default="scope">
              <span v-for="(item, index) in scope.row.cprlx" :key="index">
                <span v-if="index > 0">、</span>
                <span v-if="item==='1'">自评</span>
                <span v-if="item==='2'">班主任</span>
                <span v-if="item==='3'">授课教师</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="起止日期" prop="" width="200" align="center" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.kssj }}
              <span v-if="scope.row.kssj && scope.row.jssj">至</span>
              {{ scope.row.jssj }}
            </template>
          </el-table-column>
          <!-- 冻结列-Right BEGIN -->
          <el-table-column label="操作" width="90" fixed="right" align="center">
            <template #default="scope">
              <el-button link type="primary" @click="openPingJiaLieBiao=true; row={id:scope.row.id,pjrlx:dataGrid.parms.cprlx}">评价列表</el-button>
            </template>
          </el-table-column>
          <!-- 冻结列-Right END -->
        </el-table>
      </el-main>
    </el-container>
      <template #footer>
        <div class="dialog-footer">
        <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer_but">
            <el-button @click="openList=false;homeCloseWindow('openReturn', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <pingjialiebiao v-if="openPingJiaLieBiao" v-model:openList="openPingJiaLieBiao" :row="row" @ReturnData="bindTable" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadList, loadSelect, homeCloseWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import pingjialiebiao from './pingjialiebiao.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 加载 学期 下拉框
const xqData = ref()
loadSelect({
  url: '/api/v2/pdp/xueqi/list',
  data: xqData,
  order: 'sx',
  sort: 'asc',
  loadSuccess: function (res) {
    if (res.data.length) {
      res.data.forEach((item) => {
        if (item.sfdqxq === true) {
          dataGrid.value.parms.xqid = item.id
        }
      })
    }
  }
})

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'kssj', order: 'descending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map(item => (item.id))
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.fbzt = 1
  loadList({
    url: '/api/v2/xuesheng/deyupingjiaguanli/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
      dataGrid.value.list = res.data.list.map(item => { item.cprlx = item.cprlx.split(','); return item })
    }
  })
}
// 弹窗
const row = ref()
const openPingJiaLieBiao = ref(false)
const openList = ref(false)

watch(
  () => props.open,
  () => {
    if (props.open === 'zonghesuzhipingjiabanzhuren') {
      openList.value = true
      dataGrid.value.parms.cprlx = 2
      bindTable()
    } else if (props.open === 'zonghesuzhipingjiajiaoshi') {
      openList.value = true
      dataGrid.value.parms.cprlx = 3
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

</script>
